import type { RxJsonSchema } from 'rxdb';
import type { DeficiencyFiles } from './deficiencyFiles.types';

export const deficiencyFilesSchema: RxJsonSchema<DeficiencyFiles> = {
  type: 'object',
  version: 1,
  description: 'describes deficiency files',
  primaryKey: 'fileAimsUUID',
  properties: {
    fileId: { type: 'string' },
    fileName: { type: ['string', 'null'] },
    fileAimsUUID: { type: 'string', maxLength: 36 },
    deficiencyUUID: { type: ['string', 'null'] },
    originalFileName: { type: ['string', 'null'] },
    path: { type: ['string', 'null'] },
    legacyId: { type: ['number', 'null'] },
    assetId: { type: ['number', 'null'] },
    isImageFile: { type: ['boolean', 'null'] },
    inspectionId: { type: ['string', 'null'] },
    deficiencyId: { type: ['string', 'null'] },
    showOnReport: { type: ['boolean', 'null'] },
    fileDescription: { type: ['string', 'null'] },
    drawingType: { type: ['number', 'null'] },
    fileCategory: { type: ['number', 'null'] },
    pcsId: { type: ['string', 'null'] },
    fkAimsfileTblSp: { type: ['string', 'null'] },
    sizeMb: { type: ['number', 'null'] },
    allowSpaccess: { type: ['boolean', 'null'] },
    isReInspectedFile: { type: ['boolean', 'null'] },
    siteId: { type: ['number', 'null'] },
    disciplineId: { type: ['number', 'null'] },
    userCreated: { type: ['string', 'null'] },
    userModified: { type: ['string', 'null'] },
    extension: { type: ['string', 'null'] },
    dateCreated: { type: ['string', 'null'] },
    dateModified: { type: ['string', 'null'] },
    isDelete: { type: ['string', 'null'] },
    fileSortOrder: { type: ['number', 'null'] },
    assetInspectionTask: { type: ['number', 'null'] },
    fkInspectorField: { type: ['number', 'null'] },
    fkInspectorLead: { type: ['number', 'null'] },
    componentVersionInspectionId: { type: ['number', 'null'] },
    componentVersionId: { type: ['number', 'null'] },
    fileComponentVersionUUId: { type: ['string', 'null'] },
    isActiveDeficiencyFile: { type: ['boolean', 'null'] },
  },
};
